<template>
  <v-app>
    <v-main class="black--text">
      <fab-menu ref="fab-menu"></fab-menu>
      <v-container fluid>
        <!-- zone cible du routage de la SPA -->
        <router-view/>
      </v-container>
    </v-main>
    <v-footer app class="grey--text text--darken-3" padless>
      <v-card class="flex transparent" flat tile>
        
        <v-card-text>
          <div>
            Site réalisé avec :<v-avatar><img src="@/assets/vue_logo.png" style="width:24px; height:24px" alt="VueJS"/></v-avatar>VueJS et <v-avatar><img src="@/assets/vuetify_logo.png" style="width:20px; height:20px" alt="Vuetify"/></v-avatar>Vuetify (icônes : <i class="fab fa-font-awesome"></i> Fontawesome)
          </div>
          <div class="black--text">
            <i class="fas fa-copyright"></i> Cyril Mskine - {{ new Date().getFullYear() }}
          </div>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>
<script>
// @ is an alias to /src
import FabMenu from '@/components/FabMenu.vue'

export default {
  name: 'MainApp',
  components: {
    FabMenu
  },
  data: () => ({

  }),
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Work+Sans');

#app {
  font-family: Work sans, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #d7e2ee;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

blockquote {
	font-weight: 100;
	font-size: 1.15rem;
	max-width: 80%;
	line-height: 1.4;
	position: relative;
	margin: 0;
	padding: .5rem;
}

blockquote:before,
blockquote:after {
	position: absolute;
	color: #f1efe6;
	font-size: 8rem;
	width: 4rem;
	height: 4rem;
}

blockquote:before {
	content: '“';
	left: -5rem;
	top: -2rem;
}

blockquote:after {
	content: '”';
	right: -5rem;
	bottom: 1rem;
}
</style>